export function loadJekka() {
  setTimeout(function () {
    // 创建并引入外部JS
    const jekkaJs = document.createElement('script');
    jekkaJs.defer = true;
    if (window.location.hostname == 'www.bestdeals.co.nz') {
      jekkaJs.src = 'https://api.jekka.ai/api/v1/third/config/cs?id=tCKmfFH8HR7G6/J/Db1jOdiBoDJ8ZVA5EbA+q5wT4DE=';
    } else {
      jekkaJs.src = 'https://api.jekka.ai/api/v1/third/config/cs?id=tCKmfFH8HR7G6/J/Db1jOdiBoDJ8ZVA5EbA+q5wT4DE=';
    }
    document.body.appendChild(jekkaJs);
  }, 1);
}